export const playSound = (audioURL: string, playCount = 1): void => {
    if (playCount < 1) {
        return;
    }

    const audioInstance = new Audio(audioURL);
    audioInstance.addEventListener('ended', () => {
        playSound(audioURL, playCount - 1);
    });
    audioInstance.play();
};

export const enableSound = (): void => {
    // FIXME: simulate user's gesture to work around autoplay policy (Ծ‸ Ծ)
    const elm = document.getElementsByTagName('sfx-web-branding-logo')[ 0 ];
    elm?.dispatchEvent(new Event('click'));
};
